import { FC, useContext } from 'react';
import { CgOptions } from 'react-icons/cg';
import { Box, Button, Icon, Text } from '@chakra-ui/react';

import { DocumentListContext } from '../application';

type OpenFiltersButtonProps = {
  filtersCount: number;
};

export const OpenFiltersButton: FC<OpenFiltersButtonProps> = ({
  filtersCount,
}) => {
  const { filtersDrawerApi } = useContext(DocumentListContext);

  return (
    <Button
      borderColor="black"
      color="black"
      colorPalette="white"
      fontSize="sm"
      fontWeight="bold"
      onClick={filtersDrawerApi.onOpen}
      size="xs"
      variant="outline"
    >
      {filtersCount !== 0 ? (
        <Box
          bg="primary.500"
          borderRadius="md"
          color="white"
          px={1}
          textAlign="center"
        >
          <Text>{filtersCount}</Text>
        </Box>
      ) : (
        <Icon as={CgOptions} />
      )}
      Filters
    </Button>
  );
};
